module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    staticClass: "title-section"
  }, [_vm._v(_vm._s(_vm.t('Cheapest offers')))]), _vm._v(" "), _vm._l((_vm.offers), function(offer) {
    return _c('div', {
      staticClass: "row offers-section"
    }, [_c('div', {
      staticClass: "col-lg-2 col-md-2"
    }, [(offer['shopClassName']) ? _c('div', {
      staticClass: "shop-logo",
      class: offer['shopClassName']
    }) : _c('span', [_vm._v(_vm._s(offer['shopName']))])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-9 col-md-8"
    }, [_c('a', {
      attrs: {
        "href": offer['productLink'],
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(offer['productName']))])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-1 col-md-2"
    }, [_c('h5', {}, [_vm._v(_vm._s(offer['price']))])])])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5fbcf0d2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ProductAttribute/offers.vue
// module id = 1306
// module chunks = 2